import styled from '@emotion/styled';
import { colors } from '@/constants/colors';
import { interFontFamily } from '@/lib/fonts';

const Container = styled.span`
display: inline-flex;
width: 16px;
height: 16px;
flex-shrink: 0;
align-items: center;
justify-content: center;
background-color: ${colors.secondaryOrange};
border-radius: 4px;
color: ${colors.white};
font-family: ${interFontFamily};
font-size: 16px;
font-weight: 500;
text-align: center;
`;

const NewCircle = () => <Container><span>N</span></Container>;

export default NewCircle;
